<div class="aui-group" *ngIf="!loading; else loadingSpinner">
  <form class="aui top-label" style="display: flex; gap: 1rem; align-items: flex-end">
    <div class="field-group" style="flex: 1">
      <label for="organization">Organization</label>
      <app-select-organization
        [organizations]="organizations"
        [selectedOrganization]="activeOrganization"
        (changedorganizationEvent)="selectedOrganizationsEventHandler($event)"
      ></app-select-organization>
    </div>
    <div class="field-group" style="flex: 1">
      <label for="project">Project</label>
      <app-select-project
        [projects]="projects"
        [selectedProject]="activeProject"
        (changedProjectsEvent)="selectedProjectsEventHandler($event)"
      ></app-select-project>
    </div>
    <div class="field-group" style="flex: 1">
      <label for="task">Task</label>
      <app-select-task
        [tasks]="tasks"
        [selectedTask]="activeTask"
        (changedTasksEvent)="selectedTasksEventHandler($event)"
      ></app-select-task>
    </div>
  </form>
  <app-activities
    [timeEntries]="timeEntries"
    [loading]="loadingEntries"
    (onLinkTimeEntry)="linkTimeEntry($event)"
    (onUnlinkTimeEntry)="unlinkTimeEntry($event)"
  ></app-activities>
</div>
<ng-template #loadingSpinner>
  <div class="aui-group spinner-center">
    <p>Loading Hubstaff details...</p>
    <app-spinner></app-spinner>
  </div>
</ng-template>
